module.exports = __webpack_public_path__ + "static/media/logo-bnc.850b793a.png";